import { render, staticRenderFns } from "./post-list.vue?vue&type=template&id=7879eabc&scoped=true"
import script from "./post-list.vue?vue&type=script&lang=js"
export * from "./post-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7879eabc",
  null
  
)

export default component.exports